function prepareConfirmationAnimation(message) {
  if (message.querySelector(".gform_confirmation_message__body")) {
    return;
  }

  const body = document.createElement("div");
  body.className = "gform_confirmation_message__body";

  while (message.firstChild) {
    body.appendChild(message.firstChild);
  }

  message.appendChild(body);
}

jQuery(document).on("gform_confirmation_loaded", function (_event, formId) {
  const wrapper = document.getElementById(
    `gform_confirmation_wrapper_${formId}`,
  );

  if (!wrapper) {
    return;
  }

  const message = wrapper.querySelector(".gform_confirmation_message");
  if (message) {
    prepareConfirmationAnimation(message);
  }

  requestAnimationFrame(() => {
    wrapper.classList.add("is-success-animated");
  });

  wrapper.scrollIntoView({ behavior: "smooth", block: "center" });
});
